import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "434322243", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "headline" }, " 我是标题 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_h_deader = _resolveComponent("h-deader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_h_deader, {
      moreMenu: $setup.moreMenu,
      shareShowJudge: true,
      backgroundColor: "#000",
      fontColor: "#fff",
      ref: "headerMenu",
      skipPath: "https://www.baidu.com"
    }, {
      center: _withCtx(() => [
        _hoisted_2
      ]),
      right: _withCtx(() => [
        _createVNode(_component_van_icon, {
          name: "share-o",
          size: "22px",
          onClick: _ctx.shareEvent
        }, null, 8, ["onClick"]),
        _createVNode(_component_van_icon, {
          name: "ellipsis",
          size: "22px",
          onClick: _ctx.openMenu
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["moreMenu"])
  ], 64))
}